import { publicReportEndpoints } from '@/lib/api/endpoints';
import { operationsClient } from '@/lib/api/client';

/**
 * Browser-facing PDF URL for a public report share.
 *
 * API helpers normally receive relative paths through Axios, which applies the
 * Operations base URL. A plain anchor does not: it resolves the same path
 * against the SPA origin and lands on the frontend 404 route. Email-gated
 * shares must also carry the email used to open the hosted report.
 */
export function publicReportPdfUrl(token: string, email?: string): string {
  const path = publicReportEndpoints.pdf(token);
  const query = email ? `?${new URLSearchParams({ email }).toString()}` : '';
  const operationsBase = String(operationsClient.defaults.baseURL ?? '').replace(/\/+$/, '');
  return `${operationsBase}${path}${query}`;
}
